var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.reactiveComponent,{tag:"component",attrs:{"back":"/texting","title":"New conversation"}},[_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }